<template>
  <FormContainer>
    <template #title>Adresse du lieu de formation</template>
    <template #content>
      <div class="form__bloc">
        <BasicCheckbox
          v-if="moduleEnCours?.typeModule === 'Externe'"
          id="field_26"
          :model-value="moduleEnCours?.lieuFormationIdentiqueOf"
          @update:model-value="(value) => updateMemeLieu(value)"
          label="La formation a lieu à l'adresse de l'organisme de formation"
          class="col-36"
          :readonly
          :disabled="memeLieuDisabled"
        />
        <!-- Plus besoin de ce cas-->
        <BasicCheckbox
          v-else
          id="field_66"
          :model-value="moduleEnCours?.lieuFormationIdentiqueOf"
          @update:model-value="(value) => updateMemeLieu(value)"
          label="La formation a lieu à l'adresse de l'établissement employeur"
          class="col-36"
          :readonly
          :disabled="memeLieuDisabled"
        />
      </div>
      <div
        class="form__bloc"
        v-if="moduleEnCours?.lieuFormationIdentiqueOf === true"
      >
        <WrapperInput
          id="field_27 field_67"
          label="N° et libellé de la voie (adresse)"
          class="col-12 col-md-16 col-sm-36"
          :model-value="moduleEnCours?.lieuFormation?.voie"
          :required="
            metaModuleEnCours?.lieuFormation?.$status === PropertyStatus.Required &&
            metaModuleEnCours?.lieuFormation?.voie?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.lieuFormation?.voie?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="moduleEnCours?.lieuFormation?.complement"
          @update:model-value="(value) => updateModule('lieuFormation.complement', activeModuleIndex!, value)"
          label="Complément d'adresse"
          class="col-12 col-md-16 col-sm-36"
          :required="
            metaModuleEnCours?.lieuFormation?.$status === PropertyStatus.Required &&
            metaModuleEnCours?.etablissement?.adresse?.complement?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.etablissement?.adresse?.complement?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_28 field_68"
          :model-value="moduleEnCours?.lieuFormation?.codePostal"
          @update:model-value="(value) => updateModule('lieuFormation.codePostal', activeModuleIndex!, value)"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          :required="
            metaModuleEnCours?.lieuFormation?.$status === PropertyStatus.Required &&
            metaModuleEnCours?.lieuFormation?.codePostal?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.lieuFormation?.codePostal?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_29 field_69"
          :model-value="moduleEnCours?.lieuFormation?.commune"
          @update:model-value="(value) => updateModule('lieuFormation.commune', activeModuleIndex!, value)"
          label="Ville"
          class="col-8 col-md-10 col-sm-36"
          :required="
            metaModuleEnCours?.lieuFormation?.$status === PropertyStatus.Required &&
            metaModuleEnCours?.lieuFormation?.commune?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.lieuFormation?.commune?.$messageErreurDirty!"
          disabled
        />
      </div>
      <div
        v-else
        class="form__bloc"
      >
        <WrapperInput
          id="field_27 field_67"
          :model-value="moduleEnCours?.lieuFormation?.voie"
          @update:model-value="(value) => updateModule('lieuFormation.voie', activeModuleIndex!, value)"
          label="N° et libellé de la voie (adresse)"
          class="col-12 col-md-16 col-sm-36"
          :required="
            metaModuleEnCours?.lieuFormation?.$status === PropertyStatus.Required &&
            metaModuleEnCours?.lieuFormation?.voie?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.lieuFormation?.voie?.$messageErreurDirty!"
          :maxlength="38"
        />
        <WrapperInput
          id="field_21"
          :model-value="moduleEnCours?.lieuFormation?.complement"
          @update:model-value="(value) => updateModule('lieuFormation.complement', activeModuleIndex!, value)"
          label="Complément d'adresse"
          class="col-12 col-md-16 col-sm-36"
          :required="
            metaModuleEnCours?.lieuFormation?.$status === PropertyStatus.Required &&
            metaModuleEnCours?.lieuFormation?.complement?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.lieuFormation?.complement?.$messageErreurDirty!"
          :maxlength="38"
        />
        <WrapperInput
          id="field_28 field_68"
          :model-value="moduleEnCours?.lieuFormation?.codePostal"
          @update:model-value="(value) => updateModule('lieuFormation.codePostal', activeModuleIndex!, value)"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          :required="
            metaModuleEnCours?.lieuFormation?.$status === PropertyStatus.Required &&
            metaModuleEnCours?.lieuFormation?.codePostal?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.lieuFormation?.codePostal?.$messageErreurDirty!"
          :maxlength="5"
        />
        <WrapperInput
          id="field_29 field_69"
          :model-value="moduleEnCours?.lieuFormation?.commune"
          @update:model-value="(value) => updateModule('lieuFormation.commune', activeModuleIndex!, value)"
          label="Ville"
          class="col-8 col-md-10 col-sm-36"
          :required="
            metaModuleEnCours?.lieuFormation?.$status === PropertyStatus.Required &&
            metaModuleEnCours?.lieuFormation?.commune?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.lieuFormation?.commune?.$messageErreurDirty!"
          :maxlength="50"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/AF'
  import { AF_MODULES_ACTIONS } from '../../useModuleActions'

  const store = useDemandeAFStore()
  const { setupArrayUpdaterWithKey } = store

  const { moduleEnCours, activeModuleIndex, metaModuleEnCours, updateMemeLieu } = inject(AF_MODULES_ACTIONS)!

  const { readonly } = storeToRefs(store)

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')

  const memeLieuDisabled = computed<boolean>(() => {
    return (
      moduleEnCours.value?.modalitePedagogique === 'Afest' ||
      moduleEnCours.value?.modalitePedagogique === 'Distance' ||
      moduleEnCours.value?.modalitePedagogique === 'Foad'
    )
  })
</script>
